<div class="title" mat-dialog-title>
  <span>Report frequency matrix review</span>
</div>

<mat-dialog-content>
  <div class="message">
    Review the selected report frequency matrix types before continuing. If
    updates are needed, press Cancel and make changes in the Frequency tab
    within the Tools window.
    <br />

    <div class="frequencies">
      @for (frequency of data.frequencies; track frequency) {
      <div class="frequency">
        <span class="frequency-text">{{ frequency.text }} : </span>
        <span class="frequency-matrix">{{ frequency.matrix }} matrix</span>
        <br />
      </div>
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    class="cdx-but-md cdx-but-link"
    color="primary"
    mat-button
    (click)="cancel()"
  >
    Cancel
  </button>
  <button
    class="cdx-but-md cdx-but-link"
    color="primary"
    mat-button
    (click)="continue()"
  >
    Continue
  </button>
</mat-dialog-actions>
